import { render, staticRenderFns } from "./ContestsPage.vue?vue&type=template&id=6e8ad95b&scoped=true&lang=pug&"
import script from "./ContestsPage.vue?vue&type=script&lang=ts&"
export * from "./ContestsPage.vue?vue&type=script&lang=ts&"
import style0 from "./ContestsPage.vue?vue&type=style&index=0&id=6e8ad95b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ad95b",
  null
  
)

export default component.exports